import MetricAnalyticWithTabs from './MetricAnalyticWithTabs'

export default MetricAnalyticWithTabs
